export enum DisplayType {
    GRID = 'grid',
    LIST = 'list'
}
